import { render } from "./FormPhone.vue?vue&type=template&id=4180841a&scoped=true"
import script from "./FormPhone.vue?vue&type=script&lang=js"
export * from "./FormPhone.vue?vue&type=script&lang=js"

import "./FormPhone.vue?vue&type=style&index=0&id=4180841a&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4180841a"]])

export default __exports__